import lifeshubLogoUrl from 'bundle-text:/src/scripts/assets/lifeshub.svg'

import filterIconUrl from 'bundle-text:/src/scripts/assets/lucide-filter.svg'
import trendingUpIconUrl from 'bundle-text:/src/scripts/assets/lucide-trending-up.svg'
import circleAlertIconUrl from 'bundle-text:/src/scripts/assets/lucide-circle-alert.svg'
import eyeIconUrl from 'bundle-text:/src/scripts/assets/lucide-eye.svg'
import bookOpenIconUrl from 'bundle-text:/src/scripts/assets/lucide-book-open.svg'
import chevronRightconUrl from 'bundle-text:/src/scripts/assets/lucide-chevron-right.svg'
import chevronDownconUrl from 'bundle-text:/src/scripts/assets/lucide-chevron-down.svg'
import buildingUrl from 'bundle-text:/src/scripts/assets/lucide-building.svg'
import circleCheckBigUrl from 'bundle-text:/src/scripts/assets/lucide-circle-check-big.svg'
import triangleAlertUrl from 'bundle-text:/src/scripts/assets/lucide-triangle-alert.svg'
import circleXUrl from 'bundle-text:/src/scripts/assets/lucide-circle-x.svg'

export default {
    lifeshubLogoUrl,
    // Lucide
    filterIconUrl,
    trendingUpIconUrl,
    circleAlertIconUrl,
    eyeIconUrl,
    bookOpenIconUrl,
    chevronRightconUrl,
    chevronDownconUrl,
    buildingUrl,
    circleCheckBigUrl,
    triangleAlertUrl,
    circleXUrl
}